import "./index.css";
import "./styles/base.css";
import "./shared/config/i18n";
import { ViteReactSSG } from "vite-react-ssg";
import { routes } from "./routes";

// vite-react-ssg: prerenders every static route to HTML at build time and hydrates on the
// client. `npm run dev` still uses plain Vite (HMR); `vite-react-ssg build` does the SSG.
export const createRoot = ViteReactSSG({ routes });
